<template>
  <div class="p-0">
    <h6 class="text-two">
      {{ question.semiology_form_question_type_description }}
    </h6>
    <div
      class="form-check"
      v-for="(item, key) in question.alternatives"
      :key="key"
    >
      <input
        :disabled="form.status == 'FINALIZADO' || !linked_profile_id_can_answer"
        class="form-check-input"
        type="radio"
        :checked="item.answer"
        :name="question.id"
        :value="item.id"
        :id="`single-choice-${item.id}`"
        @input="emit($event.target.value)"
      />
      <label :for="`single-choice-${item.id}`" class="form-check-label">
        {{ item.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",

  props: {
    linked_profile_id_can_answer: {
      type: Boolean,
      default: true,
    },

    form: Object,
    category_id: [String, Number],
    question: Object,
  },

  methods: {
    emit(answer) {
      this.$emit("answer", {
        category_id: this.category_id,
        id: this.question.id,
        answer,
      });
    },
  },
};
</script>
